/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import { useStore, useDispatch } from 'react-redux'
import SlidingPane from '@zilahir/react-sliding-pane'
import '@zilahir/react-sliding-pane/dist/react-sliding-pane.css'
import ReactJson from 'react-json-view'
import ReactPaginate from 'react-paginate'
import Icon from 'react-icons-kit'
import { folder } from 'react-icons-kit/feather/'
import { chevronLeft } from 'react-icons-kit/feather/chevronLeft'
import styled from 'styled-components'
import Dropdown from '@zilahir/react-dropdown'

import styles from './SlidePane.module.scss'
import paginationStyles from './Pagination.module.scss'
import { checkIfJsonIsValid } from '../../utils/jsonValidator'
import { setJson } from '../../store/actions/setJson'
import InvoiceList from '../common/InvoiceList'
import '@zilahir/react-dropdown/style.css'

/**
* @author zilahir
* @function Slidingpage
* */

const Header = props => {
	const { count } = props
	return (
		<div className={styles.header}>
			<h1>
				Your invoices <span>{count}</span>
			</h1>
		</div>
	)
}

Header.propTypes = {
	count: PropTypes.number.isRequired,
}

const sortingOptions = [
	{ value: 'asc', label: 'Ascending' },
	{ value: 'desc', label: 'Descending' },
]

const SlidingPange = () => {
	const [isPaneOpen, togglePane] = useState(false)
	const [jsonVal, setJsonVal] = useState()
	const [isJsonFormatted, setFormattedJson] = useState(false)
	const [userssInvoiceList, setUsersInvoiceList] = useState([])
	const modalRef = useRef()
	// eslint-disable-next-line no-unused-vars
	const store = useStore()
	const dispatch = useDispatch()

	const IconContainer = styled.div`
		color: #fff;
		padding: 10px;
	`
	useEffect(() => {
		Modal.setAppElement(modalRef.current)
		setUsersInvoiceList(store.getState().invoices.userInvoices)
	}, [dispatch])

	function formatJson() {
		setFormattedJson(!isJsonFormatted)
		dispatch(setJson(JSON.parse(jsonVal).fields))
	}

	function handleChange(value) {
		setJsonVal(value)
	}

	function handlePageClick() {
		return true
	}

	return (
		<div ref={modalRef}>
			<button className={styles.button} type="button" onClick={() => togglePane(!isPaneOpen)}>
				<IconContainer>
					<Icon icon={folder} />
				</IconContainer>
			</button>
			<SlidingPane
				className={styles.slidingPaneContainer}
				overlayClassName="some-custom-overlay-class"
				isOpen={isPaneOpen}
				title={<Header count={userssInvoiceList.length} />}
				subtitle={null}
				onRequestClose={() => togglePane(false)}
				headerClass={styles.slidingPaneHeader}
				wrapperClass={styles.wrapperClass}
				innerWrapperClass={styles.innerContainer}
				closeIcon={(
					<div style={{ color: '#fff' }}>
						<Icon size="2em" icon={chevronLeft} />
					</div>
				)}
			>
				<div className={styles.jsonValContainer}>
					<button style={{ display: 'none' }} type="button" onClick={() => formatJson()}>
						{
							!isJsonFormatted ? 'format json' : 'show raw format'
						}
					</button>
					<div style={{ display: 'none' }}>
						{
							!isJsonFormatted
								? (
									<textarea
										className={styles.jsonVal}
										onChange={e => handleChange(e.target.value)}
										value={jsonVal}
									/>
								)
								: checkIfJsonIsValid(jsonVal)
									? <ReactJson src={JSON.parse(jsonVal)} />
									: null
						}
					</div>
					{
						userssInvoiceList.length > 10
							? (
								<div className={paginationStyles.rootContainer}>
									<ReactPaginate
										previousLabel={null}
										nextLabel={null}
										breakLabel="..."
										breakClassName={paginationStyles.break}
										pageCount={3}
										marginPagesDisplayed={2}
										pageRangeDisplayed={5}
										onPageChange={handlePageClick}
										containerClassName={paginationStyles.paginationContainer}
										subContainerClassName={paginationStyles.innerContainer}
										activeClassName={paginationStyles.active}
										pageClassName={paginationStyles.paginationItem}
									/>
									<Dropdown
										onChange={() => null}
										className={styles.dropdown}
										options={sortingOptions}
										controlClassName={styles.dropdownControl}
										value={sortingOptions[0]}
										placeholderClassName={styles.placeholder}
										arrowClassName={styles.arrow}
									/>
								</div>
							) : null
					}
					{
						userssInvoiceList.map((currentInvoice, i) => (
							<InvoiceList
								date={currentInvoice.created_at}
								shallClosePane={bool => togglePane(bool)}
								title={currentInvoice.title}
								jsonValue={currentInvoice.json}
								isOdd={i % 2 === 0 ? 'odd' : 'even'}
								key={i}
							/>
						))
					}
				</div>
			</SlidingPane>
		</div>
	)
}

export default SlidingPange
